import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button'
import FilterModal from '@/components/FilterModal'
import { GlobalAdminDashboardPayload } from '@/services/types/APIRequestType'
import { GlobalAdminDashboardResponse } from '@/services/types/APIResponseType'
import useGlobalAdminDashboard from '@/services/hooks/usePostGlobalAdminDashboard'
import useLocalStorage from '@/hooks/useLocalStorage'
import Path from '@/router/localRoutes'
import { AdminRole } from '@/utils/config/auth-enums'
import { TimePeriod } from '@/utils/config/user-enums'
import { formatNumbers, getDateRange } from '@/utils'
import './DashboardContent.css'

const DashboardContent = () => {
  const [roleValue] = useLocalStorage('role')
  const navigate = useNavigate()
  const [activeFilter, setActiveFilter] = useState<TimePeriod>(TimePeriod.ALL)
  const [open, setOpen] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<GlobalAdminDashboardResponse>({
    registeredConsumers: 0,
    registeredBabysitters: 0,
    totalCheckIns: 0,
    totalRevenue: 0,
  })

  const role = roleValue
  const dashboardContent = [
    {
      iconSrc: '/icon/Registered numbers.svg',
      mainLabel: 'Total Number of Registered',
      subLabel: 'Participant',
      totalCount: `${formatNumbers(totalCount?.registeredConsumers)}`,
      roles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
      route: 'reg-participant',
    },
    {
      iconSrc: '/icon/Registered numbers.svg',
      mainLabel: 'Total Number of Registered',
      subLabel: 'Supervisors',
      totalCount: `${formatNumbers(totalCount?.registeredBabysitters)}`,
      roles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
      route: 'reg-supervisor',
    },
    {
      iconSrc: '/icon/check-in.svg',
      mainLabel: 'Total Number of',
      subLabel: 'Check Ins',
      totalCount: `${formatNumbers(totalCount?.totalCheckIns)}`,
      roles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
      route: 'dashboard',
    },
    {
      iconSrc: '/icon/Revenue.svg',
      mainLabel: 'Total',
      subLabel: 'Revenue Generated',
      totalCount: `$${formatNumbers(totalCount?.totalRevenue)}`,
      roles: [AdminRole.GLOBAL_ADMIN],
      route: 'dashboard',
    },
  ]
  const roleBasedDashboardContent = dashboardContent.filter((card) =>
    card.roles.includes(role),
  )

  const handleClose = () => setOpen(false)
  const handleOpen = () => setOpen(true)

  const { mutate: getAdminDashboardData } = useGlobalAdminDashboard()

  const fetchAdminDashboardData = useCallback(
    (requestData: GlobalAdminDashboardPayload) => {
      getAdminDashboardData(requestData, {
        onSuccess: (response) => {
          if (response) {
            setTotalCount(response.data)
          }
        },
      })
    },
    [getAdminDashboardData],
  )

  const handleFilterChange = (filter: TimePeriod) => {
    setActiveFilter(filter)
  }

  useEffect(() => {
    fetchAdminDashboardData(getDateRange(activeFilter))
  }, [activeFilter, fetchAdminDashboardData])

  return (
    <div>
      <div className="dashboard-filter">
        <Button onClick={handleOpen}>
          <img src="/icon/Filter 1.png" alt="Date filter icon" />
        </Button>
      </div>

      <FilterModal
        open={open}
        handleClose={handleClose}
        activeFilter={activeFilter}
        handleFilterChange={handleFilterChange}
      />

      <div className="dashboard-content-wrapper">
        {roleBasedDashboardContent.map((item, index) => (
          <div
            key={index}
            className="cursor-pointer dashboard-content-block "
            onClick={() => navigate(`${Path.AdminDashboard}?tab=${item.route}`)}
          >
            <img src={item.iconSrc} alt="Menu icon" />
            <label className="d-content-label1">{item.mainLabel}</label>
            <label className="d-content-label2">{item.subLabel}</label>
            <b>{item.totalCount}</b>
          </div>
        ))}
      </div>
    </div>
  )
}

export default DashboardContent
